<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ t('common.order.detail') }}</div>
      <div class="text_box">
        <div class="top_title">{{ t('common.base.info') }}</div>
        <div><span class="left_title">{{ t('common.order.number') }}</span><span class="inner">{{
            selectObj.orderCode
          }}</span></div>
        <div><span class="left_title">{{ t('common.order.amount') }}</span><span class="inner">{{
            formatMoney(selectObj.totalMoney)
          }}</span></div>
        <!--        <div><span class="left_title">Plus会员优惠</span><span class="inner"></span></div>-->
        <!--        <div><span class="left_title">会员活动优惠</span><span class="inner"></span></div>-->
        <div><span class="left_title">{{ t('common.amount.realpay') }}</span><span
            class="inner">{{ formatMoney(selectObj.payMoney) }}</span></div>
      </div>
      <div>
        <el-table :data="tableData"
                  style="width: 100%"
                  v-loading="loading"
                  :cell-style="rowClassName"
                  :header-cell-style="headerClassName"
        >
         <!-- <el-table-column prop="id" :label="t('common.cds83')" width="180"/>-->
          <el-table-column prop="productName" :label="t('common.productandservice')" width="180">
            <template #default="{row}">
              <template v-if="row.productType&&row.productType<=4">
                {{ t(`userinfo.vip.service.${row.productType}`) }}
              </template>
              <template v-else-if="row.productType&&row.productType>4">
                {{ t(`vip.type.${row.productType - 5}`) }}
              </template>
              <template v-else></template>
            </template>
          </el-table-column>
          <el-table-column prop="num" :label="t('common.amount')"/>
          <el-table-column prop="price" :label="t('common.unitprice')">
            <template #default="{ row }">
              {{ formatMoney(row.price) }}
            </template>
          </el-table-column>
          <el-table-column prop="totalMoney" :label="t('common.order.amount')">
            <template #default="{ row }">
              {{ formatMoney(row.totalMoney) }}
            </template>
          </el-table-column>
          <el-table-column prop="payMoney" :label="t('common.amount.realpay')">
            <template #default="{ row }">
              {{ formatMoney(row.payMoney) }}
            </template>
          </el-table-column>
        </el-table>
        <div class="bottom_pay">{{ t('common.order.amount.total') }}{{ labelSeparator }}<span class="reds">
          {{
            formatMoney(selectObj.totalMoney)
          }}</span></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, onMounted} from 'vue';
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import {getQueryById} from "@/api/usercenter";
import {ElMessage} from "element-plus";

const router = useRouter();
const {t, locale} = useI18n();
const loading = ref(false)

const orderCode = ref()
const tableData = ref([])
const selectObj = ref({})

const currentLocale = computed(() => locale.value === 'en' ? 'en-US' : 'zh-CN')
const labelSeparator = computed(() => locale.value === 'en' ? ': ' : '：')

const formatMoney = (value) => {
  const amount = Number(value)
  if (Number.isNaN(amount)) return value ?? '--'
  return `¥ ${amount.toFixed(2)}`
}

// 通过 id 查询数据
const getQueryByIdApis = async () => {
  loading.value = true
  const res = await getQueryById(
      {orderCode: orderCode.value}
  )
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  loading.value = false
  selectObj.value = res.result.mailPayOrder;
  tableData.value = res.result.mailPayOrderTmpList
  console.log(selectObj, tableData, 'ff')
}
onMounted(async () => {
  const {payCode} = router.currentRoute.value.query
  orderCode.value = payCode
  await getQueryByIdApis()
})


const rowClassName = () => {
  return {textAlign: 'center'}
}

const headerClassName = () => {
  return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px', 'white-space': 'nowrap'}
}
</script>

<style lang="less" scoped>
@import "./less/Tables.less";

.right {
  height: max-content !important;
  padding-bottom: 40px !important;
}

.text_box {
  & > div {
    margin-bottom: 16px;
  }
}

.left_title {
  color: #999;
  margin-right: 20px;
  font-size: 14px;
}

.bottom_pay {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;

  .reds {
    color: var(--el-color-danger);
    font-size: 14px;
    font-weight: bold;
  }
}

.inner {
  font-size: 14px;
  font-weight: bold;
}


:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-table th .cell) {
  white-space: nowrap !important;
}
</style>
